import script from "./ImportKaigoNoMori.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportKaigoNoMori.vue?vue&type=script&setup=true&lang=js"

import "./ImportKaigoNoMori.vue?vue&type=style&index=0&id=c7d30b2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7d30b2e"]])

export default __exports__